module.exports = __webpack_public_path__ + "img/bild1.e1d720ea.jpeg";